import { gql } from '@apollo/client';

export const UPDATE_CUSTOM_STAGE_TASK_DETAILS = gql`
  mutation UpdateCustomStageTaskDetails($data: UpdateMemberStageTaskInput!) {
    updateStageTaskDetails(data: $data)
  }
`;
